import AUDIO_URL from 'common/sound/elevator_ding.mp3';

const LOGO = '../img/logo_o@3x.png';
// below, could be used to tag particular notifications.
const sequenceNumber = () => {
    let number = 1;
    return () => {
        return number++;
    };
};

export const WebNotificationState = {
    PERMISSION_GRANTED: 'granted',
    PERMISSION_DENIED: 'denied',
    DEFAULT: 'default'
};

class WebNotificationService {
    constructor() {
        this.getSequenceNumber = sequenceNumber();
        this.init();
    }

    init = () => {
        //init audio
        this.audio = new Audio(AUDIO_URL);
    };

    playAudio = () => {
        const { audio } = this;
        audio.play().catch(_ => {});
    };

    onClickHandler = (boundRouters, note, e) => {
        e.preventDefault();
        if (boundRouters) {
            boundRouters();
            note.close.call(note);
        }
    };
    /**
     * This function checks for 'new Notification()' support in the browser.
     * Reference:
     * https://developers.google.com/web/updates/2015/05/notifying-you-of-changes-to-notifications#android_notifications
     */
    isNewNotificationSupported = () => {
        if (!window.Notification || !Notification.requestPermission)
            return false;
        if (
            Notification.permission === WebNotificationState.PERMISSION_GRANTED
        ) {
            return true;
        }
        try {
            new Notification('');
        } catch (e) {
            if (e.name === 'TypeError') {
                return false;
            }
        }
        return true;
    };

    showNotification = (title, options, permission, params) => {
        if (permission === WebNotificationState.PERMISSION_GRANTED) {
            const { boundRouters } = params;
            var note = new Notification(title, options);
            note.onclick = this.onClickHandler.bind(this, boundRouters, note);
            this.playAudio();
            setTimeout(note.close.bind(note), 25000);
        }
    };

    spawnNotification = (title, body, icon = LOGO, params) => {
        const tag = `Notification - ${this.getSequenceNumber()}`;
        var options = {
            body,
            icon,
            tag
        };

        if (
            Notification.permission === WebNotificationState.PERMISSION_GRANTED
        ) {
            this.showNotification(
                title,
                options,
                Notification.permission,
                params
            );
        } else {
            Notification.requestPermission().then(permission => {
                this.showNotification(title, options, permission, params);
            });
        }
    };
}

export default WebNotificationService;
